import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { CSSTransition } from 'react-transition-group';

import { initTooltipAction, switchTooltipAction } from './actions';
import { ReactComponent as IconClose } from '../../assets/close-popup.svg';

import './style.scss';

class Tooltip extends React.Component {
    constructor() {
        super();

        this.tooltipID = `tooltip-${this.randomID(10)}`;
        this.wrapperRef = React.createRef();
    }

    componentDidMount() {
        const {
            dispatch,
            text,
            name,
            showInMobile
        } = this.props;
        dispatch(initTooltipAction(text, this.tooltipID, name, showInMobile));
        this.wrapperRef.current.addEventListener('mouseenter', e => this.onMouseEnter(e));
        this.wrapperRef.current.addEventListener('mouseleave', e => this.onMouseLeave(e));
    }

    randomID = (length) => {
        let result = '';
        const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        const charactersLength = characters.length;
        for (let i = 0; i < length; i++) {
            result += characters.charAt(Math.floor(Math.random() * charactersLength));
        }
        return result;
    }

    onMouseEnter = (e) => {
        const { dispatch } = this.props;
        const elemTarget = e.srcElement;
        const tooltipID = elemTarget.getAttribute('tooltipid');
        dispatch(switchTooltipAction(tooltipID));
    }

    onMouseLeave = (e) => {
        const { dispatch } = this.props;
        const elemTarget = e.srcElement;
        const tooltipID = elemTarget.getAttribute('tooltipid');
        dispatch(switchTooltipAction(tooltipID));
    }

    render() {
        const { children } = this.props;
        const newChildren = React.cloneElement(children, { tooltipid: this.tooltipID, ref: this.wrapperRef });
        return newChildren;
    }
}

Tooltip.defaultProps = {
    text: [],
    showInMobile: true,
    name: ''
};

Tooltip.propTypes = {
    children: PropTypes.object.isRequired,
    dispatch: PropTypes.func.isRequired,
    text: PropTypes.array,
    name: PropTypes.string,
    showInMobile: PropTypes.bool
};

const mapStateToProps = state => ({
    tooltips: state.tooltips
});


export default connect(mapStateToProps)(Tooltip);
